import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { RawHtml } from './RawHtml';

export const CommentsSection = ({ children: commentsHtml, title, placeholder }) => (
  <Card className="haz-comments-section">
    <CardBody>
      <CardTitle>{title}</CardTitle>
      <div className="haz-comments-block">
        {commentsHtml ? (<RawHtml>{commentsHtml}</RawHtml>) : (<p>{placeholder}</p>)}
      </div>
    </CardBody>
  </Card>
);

CommentsSection.propTypes = {
  children: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
};

CommentsSection.defaultProps = {
  children: '',
  title: 'Comments',
  placeholder: 'No Comments Available',
};
